import Vue from "vue";
import { FORM_TYPE, LIST_FIELDS_NO_MODEL } from "../constants/custom-define-type";
import { CONDITION_OPERATOR_OPTIONS } from "../constants/condition-params";
import { REGEX_NORMALIZE_TEXT } from "../constants/regex";
import { DEFAULT_PROFILE_IMAGE_SUFFIX } from "../constants/default-values";
import { RADIO_OTHER_OPTIONS_PREFIX } from "../constants/prefix";
import { MAP_DIALOG_SECTION } from "../constants/field-types";

Vue.mixin({
  methods: {
    getValueOfObjectKey(dataObject, key) {
      if (!key) {
        return null;
      }
      const tokens = key.split(/[\.\[\]]+/);
      let objValue = dataObject;
      for (const token of tokens) {
        if (token.length === 0) {
          continue;
        }
        if (objValue == null && dataObject[key]) {
          return dataObject[key];
        }
        objValue = objValue[token];
      }
      return objValue;
    },
    isMissingField(dataObject, field) {
      const type = field.type;
      if ([FORM_TYPE.FILE_WITH_INFO, FORM_TYPE.HTML, FORM_TYPE.LABEL, FORM_TYPE.SUB_HEADER,
      FORM_TYPE.CREDIT_PACKAGE_SELECTION, FORM_TYPE.STRIPE_SUBSCRIPTION_SELECTION,
      FORM_TYPE.DATA].includes(type)) {
        return false;
      }
      if (LIST_FIELDS_NO_MODEL.includes(type)) {
        return false;
      }
      const fieldName = field.model;
      // Ignore the file which has initialUrl
      if (type === FORM_TYPE.FILE) {
        if (field.initialUrl != null) {
          return false;
        }
      }
      const objValue = this.getValueOfObjectKey(dataObject, fieldName);
      if (objValue == null) {
        console.log('isMissingField', fieldName);
        return true;
      }
      if (type === FORM_TYPE.DAY_HOURS_SELECTOR) {
        /*
        objValue includes 5 element (corresponding with Monday -> Friday)
        Each row of day hours selector includes a checkbox, and two time picker
        If the checkbox is not check, the corresponding value is "" (empty string)
        If the checkbox is checked, but none of the time picker is filled, the value is ","
        If the checkbox is checked, but the 'from' time picker is not filled, the value is ",to"
        If the checkbox is checked, but the 'to' time picker is not filled, the value is "from,"
        */

        // Check if all checkbox is unchecked.
        if (!objValue.some(val => val != null && val !== "")) {
          console.log('isMissingField objValue', objValue);
          return true;
        }
        if (objValue != null && Array.isArray(objValue)) {
          for (const val of objValue) {
            // If value contains ',' => checkbox is checked.
            if (val && val.includes(",")) {
              const tokens = val.split(",");
              for (const token of tokens) {
                // Check if 'from' or 'to' is missing
                if (token.trim().length === 0) {
                  console.log('isMissingField objValue val', val);
                  return true;
                }
              }
            }
          }
        }
      }

      if (type === FORM_TYPE.SALARY_RANGE) {
        // objValue of salary range includes 3 element (min salary, max salary, salary option)
        // If any of those value is empty => the field is not filled
        if (objValue == null) {
          console.log('isMissingField Salary range', field);
          return true;
        }
        if (objValue != null && Array.isArray(objValue)) {
          const minSalary = objValue[0];
          const maxSalary = objValue[1];
          const period = objValue[2];
          // Check require for min value and max value
          if (!minSalary || !maxSalary) {
            console.log('isMissingField Salary range', objValue, field);
            return true;
          }
          // In case of period option is hidden, no need to check period value
          if (!field.hidePeriod && !period) {
            console.log('isMissingField Salary range period', field);
            return true;
          }
        }
      }

      // Check for time picker
      if (type === FORM_TYPE.TIME_PICKER) {
        if (objValue == null) {
          console.log('isMissingField Timepicker', field, objValue);
          return true;
        }
        if (typeof objValue === "object") {
          if (objValue.hh == null || objValue.hh === "") {
            console.log('isMissingField Timepicker 1', field, objValue);
            return true;
          }
          if (objValue.mm == null || objValue.mm === "") {
            console.log('isMissingField Timepicker 2', field, objValue);
            return true;
          }
          if (objValue.A == null || objValue.A === "") {
            console.log('isMissingField Timepicker 3', field, objValue);
            return true;
          }
        }
      }

      if (type === FORM_TYPE.LANGUAGE_INPUT) {
        // Structure of each element in array is item: option1, option2
        if (objValue == null) {
          console.log('isMissingField language input', field, objValue);
          return true;
        }
        if (objValue != null && Array.isArray(objValue)) {
          // Empty array
          if (objValue.length === 0) {
            console.log('isMissingField language input 1', field, objValue);
            return true;
          }
          const listHeaderIndex = this.findHeaderIndex(field);
          for (let index = 0; index < objValue.length; index++) {
            // Exclude header
            if (listHeaderIndex.includes(index)) {
              console.log('isMissingField language input 2', field, objValue);
              continue;
            }
            const val = objValue[index];
            // Empty element
            if (!val) {
              console.log('isMissingField language input 3', field, objValue);
              return true;
            }
            const tokens = val.split(":");
            if (tokens.length < 2) {
              console.log('isMissingField language input 4', field, objValue);
              return true;
            }
            // Item is not inputted
            if (tokens[0].trim().length === 0) {
              console.log('isMissingField language input 5', field, objValue);
              return true;
            }
            // No option is selected
            if (tokens[1].trim().length === 0) {
              console.log('isMissingField language input 6', field, objValue);
              return true;
            }
          }
          return false;
        }
      }
      if (type === FORM_TYPE.CHECKBOX_TABLE) {
        // Structure of each element in array is item: option1, option2
        if (objValue == null) {
          console.log('isMissingField checkbox table', field, objValue);
          return true;
        }
        if (objValue != null && Array.isArray(objValue)) {
          // Empty array
          if (objValue.length === 0) {
            console.log('isMissingField checkbox table 1', field, objValue);
            return true;
          }
          const listHeaderIndex = this.findHeaderIndex(field);
          let hasCheckedValue = false;
          for (let index = 0; index < objValue.length; index++) {
            // Exclude header
            if (listHeaderIndex.includes(index)) {
              continue;
            }
            const val = objValue[index];
            // Empty element
            if (!val) {
              continue;
            }
            const tokens = val.split(":");
            if (tokens.length < 2) {
              continue;
            }
            // Item is not inputted
            if (tokens[0].trim().length === 0) {
              continue;
            }
            // No option is selected
            if (tokens[1].trim().length === 0) {
              continue;
            }
            hasCheckedValue = true;
          }
          if (!hasCheckedValue) {
            console.log('isMissingField checkbox table 2', field, objValue);
          }
          return !hasCheckedValue;
        }
      }
      return this.isEmptyValue(objValue);
    },
    /* Find index of header in list item
    For example: itemList: option1, option2, option3, option4
    headerList: option1, option3
    => header index: 0, 2
    */
    findHeaderIndex(field) {
      if (!field.headerList || !field.itemList) {
        return [];
      }
      const headerList = field.headerList
        .split("\n")
        .map(header => header.trim())
        .filter(header => header.length > 0);
      const itemList = field.itemList
        .split("\n")
        .map(item => item.trim())
        .filter(item => item.length > 0);
      const listHeaderIndex = [];
      for (let index = 0; index < itemList.length; index++) {
        const item = itemList[index];
        if (headerList.includes(item)) {
          listHeaderIndex.push(index);
        }
      }
      return listHeaderIndex;
    },
    isEmptyValue(val) {
      // Check null
      if (val == null) {
        return true;
      }
      // Empty string
      if (typeof val === "string") {
        val = this.removeOtherRadioPrefix(val);
        if (val.trim().length === 0) {
          return true;
        }
      }
      if (typeof val === "object") {
        if (Array.isArray(val)) {
          // Empty array
          if (val.length === 0) {
            return true;
          }
        } else if (!(val instanceof Date) && !(val instanceof File)) {
          // Empty object
          if (Object.keys(val).length === 0) {
            return true;
          }
        }
      }
      return false;
    },
    hasInvalidField(dataObject, listElement, ignoreMissing = false) {
      for (const element of listElement) {
        // Ignore the field which is not show
        if (!this.isItemShow(dataObject, element, listElement)) {
          continue;
        }
        if (element.validation) {
          const objValue = this.getValueOfObjectKey(dataObject, element.model);
          if (objValue != null && objValue !== "") {
            for (const validateItem of element.validation) {
              try {
                if (!validateItem.regex.test(objValue)) {
                  console.log('hasInvalidField regex', objValue)
                  return {
                    field: element,
                    value: objValue,
                    type: 'Invalid Input'
                  };
                }
              } catch (e) {
                continue;
              }
            }
          }
        }
        if (element.isRequired === false) {
          continue;
        }
        if (!element.model) {
          continue;
        }
        if (!ignoreMissing) {
          if (this.isMissingField(dataObject, element)) {
            console.log('Missing field', element);
            return {
              field: element,
              type: 'Required Field'
            };
          }
        }
        // Validate for start date and end date
        if (element.type === FORM_TYPE.MONTH_PICKER) {
          // Validate for case of start date and end date
          if (element.after != null) {
            // End date
            const endDate = this.getValueOfObjectKey(dataObject, element.model);
            // Start date
            const startDate = this.getValueOfObjectKey(
              dataObject,
              element.after
            );
            if (this.compareMonthYear(endDate, startDate) < 0) {
              console.log('End date before start date', endDate, startDate);
              return {
                message: 'End date before start date'
              };
            }
          }
        }
      }
      return false;
    },
    getListMissingFields(dataObject, listElement) {
      const result = [];
      for (const element of listElement) {
        // Ignore the field which is not show
        if (!this.isItemShow(dataObject, element, listElement)) {
          continue;
        }
        if (element.isRequired === false) {
          continue;
        }
        if (!element.model) {
          continue;
        }
        if (this.isMissingField(dataObject, element)) {
          result.push(element);
        }
      }
      return result;
    },
    /* Compare month year of date1, date2
    Input format yyyy-MM-dd
    Return 1 if month-year of date1 > month-year of date2
    Return 0 if equal
    return -1 if  month-year of date1 < month-year of date2
    */
    compareMonthYear(date1, date2) {
      const tokens1 = date1.split("-");
      const tokens2 = date2.split("-");
      // Compare year
      if (Number(tokens1[0]) > Number(tokens2[0])) {
        return 1;
      } else if (Number(tokens1[0]) < Number(tokens2[0])) {
        return -1;
      }
      // Compare month
      if (Number(tokens1[1]) > Number(tokens2[1])) {
        return 1;
      } else if (Number(tokens1[1]) < Number(tokens2[1])) {
        return -1;
      }
      return 0;
    },
    hasMissingRequireFieldByKeys(
      dataObject,
      listRequiredField,
      listRequiredCheckbox = null
    ) {
      for (const requiredField of listRequiredField) {
        const objValue = this.getValueOfObjectKey(dataObject, requiredField);
        if (objValue == null) {
          return true;
        }
        // Empty string
        if (typeof objValue === "string") {
          if (objValue.length === 0) {
            return true;
          }
        }
        if (typeof objValue === "object") {
          if (Array.isArray(objValue)) {
            // Empty array
            if (objValue.length === 0) {
              return true;
            }
          } else if (!(objValue instanceof Date)) {
            // Empty object
            if (Object.keys(objValue).length === 0) {
              return true;
            }
          }
        }
      }

      if (listRequiredCheckbox != null) {
        for (const checkboxField of listRequiredCheckbox) {
          const objValue = this.getValueOfObjectKey(dataObject, checkboxField);
          if (objValue != true) {
            return true;
          }
        }
      }
      return false;
    },
    getFirstNameAndLastName(name) {
      const trimedName = name.trim();
      if (trimedName.includes(" ")) {
        const spaceIndex = trimedName.indexOf(" ");
        const firstName = trimedName.substr(0, spaceIndex).trim();
        const lastName = trimedName.substr(spaceIndex + 1);
        return { firstName: firstName, lastName: lastName };
      } else {
        return { firstName: trimedName, lastName: "" };
      }
    },
    extractSelectedFields(inputObject, listFields, includeFileUrl = false) {
      if (!inputObject) {
        return {};
      }
      const listFieldsExcludeUnchangeFile = listFields.filter(field => {
        if (field.type === FORM_TYPE.FILE) {
          if (!includeFileUrl) {
            if (typeof inputObject[field.model] === "string") {
              return false;
            }
          }
          return true;
        } else {
          return true;
        }
      });
      const listSelectedKey = listFieldsExcludeUnchangeFile.map(
        field => field.model
      );
      const result = {};
      for (const key of Object.keys(inputObject)) {
        if (listSelectedKey.includes(key)) {
          result[key] = inputObject[key];
        }
      }
      return result;
    },
    isUnchangedObject(objectOrigin1, objectOrigin2, listFields) {
      let object1 = objectOrigin1;
      let object2 = objectOrigin2;
      if (object1 == null) {
        object1 = {};
      }
      if (object2 == null) {
        object2 = {};
      }
      if (listFields == null) {
        const listModels = this.deduplicateArray([...Object.keys(object1), ...Object.keys(object2)]);
        listFields = listModels.map(model => {
          return {
            model: model
          }
        });
      }
      for (const field of listFields) {
        const key = field.model;
        if (!object1[key] && !object2[key]) {
          continue;
        }
        // First value is empty array, and second value is null => equal
        if (Array.isArray(object1[key])) {
          if (object1[key].length === 0 && object2[key] == null) {
            continue;
          }
        }

        // First value is null, second value is empty array => equal
        if (Array.isArray(object2[key])) {
          if (object2[key].length === 0 && object1[key] == null) {
            continue;
          }
        }

        // Both value are arrays
        if (Array.isArray(object1[key]) && Array.isArray(object2[key])) {
          if (object1[key].length !== object2[key].length) {
            return false;
          }
          for (let index = 0; index < object1[key].length; index++) {
            if (object1[key][index] !== object2[key][index]) {
              try {
                if (JSON.stringify(object1[key][index]) == JSON.stringify(object2[key][index])) {
                  continue;
                }
              } catch (_) {
              }
              return false;
            }
          }
        } else if (typeof object1[key] === 'object' && typeof object2[key] === 'object') {
          // Both value are object, compare value of all keys
          for (const key1 of Object.keys(object1[key])) {
            if (!object1[key][key1] && !object2[key][key1]) {
              continue;
            }
            if (object1[key][key1] !== object2[key][key1]) {
              return false;
            }
          }
        } else if (object1[key] !== object2[key]) {
          // The field is changed by default value
          if (!this.isFieldChangeByDefaultValue(field, object1[key], object2[key])) {
            return false;
          }
        }
      }
      return true;
    },
    isUnchangedList(oldList, newList, listFields = null) {
      if (!oldList) {
        oldList = [];
      }
      if (!newList) {
        newList = [];
      }
      if (oldList.length != newList.length) {
        return false;
      }
      for (let index = 0; index < oldList.length; index++) {
        if (!this.isUnchangedObject(oldList[index], newList[index], listFields)) {
          return false;
        }
      }
      return true;
    },
    isFieldChangeByDefaultValue(field, oldVal, newVal) {
      if (!field || !field.defaultValue) {
        return false;
      }
      if ((oldVal == null) || (oldVal === '')) {
        if (newVal == field.defaultValue) {
          return true;
        }
      }
      return false;
    },
    // Get field which corresponding with Show If Condition
    getReferField(field, listFields, key = 'showIf') {
      if (!field || !listFields) {
        return;
      }
      // Has no 'Show Condition'
      if (!field[key]) {
        return;
      }
      const listReferFields = listFields.filter(item => item.model === field[key]);
      if (!listReferFields.length) {
        return;
      }
      // Only one match
      if (listReferFields.length === 1) {
        return listReferFields[0];
      }
      // Multiple matches
      const fieldIndex = listFields.indexOf(field);
      if (fieldIndex === -1) {
        // Cannot find field inside listFields => get first item
        return listReferFields[0];
      }
      // Get the nearest field which is appeared before the field
      for (let index = fieldIndex - 1; index >= 0; index--) {
        if (listFields[index].model === field[key]) {
          return listFields[index];
        }
      }
      // Get the nearest field which is appeared after the field
      for (let index = fieldIndex + 1; index < listFields.length; index++) {
        if (listFields[index].model === field[key]) {
          return listFields[index];
        }
      }
      return listReferFields[0];

    },
    // Check if item is showed (Item may not showed if showIf is set)
    // If isAnnonymousAccess = true, logged in user access as annonymous
    isItemShow(modelData, el, listElements, isAnnonymousAccess = false) {
      // Admin only field
      if (el.isAdminOnly) {
        if (isAnnonymousAccess) {
          return false;
        }
        if (!this.$store.getters.isAgent) {
          return false;
        }
      }
      // Check combined show conditions
      if (el.combinedShowCondition) {
        if (this.hasSearchCondition(el.combinedShowCondition)) {
          if (!this.isMatchCombinedConditions([el.combinedShowCondition], modelData)) {
            return false
          }
        }
      }
      if (el.combinedShowConditionContainer) {
        if (this.hasSearchCondition(el.combinedShowConditionContainer)) {
          if (!this.isMatchCombinedConditions([el.combinedShowConditionContainer], modelData)) {
            return false
          }
        }
      }
      const isItemShowed = this.isItemShowByKey(modelData, el, listElements, 'showIf', 'showIfEmpty', 'showIfValue', 'showIfValueNot', 'showIfNotEmpty');
      const isItemShowedSecondary = this.isItemShowByKey(modelData, el, listElements, 'showIfSecondary', 'showIfEmptySecondary', 'showIfValueSecondary', 'showIfValueNotSecondary', 'showIfNotEmptySecondary');
      const isItemShowedThird = this.isItemShowByKey(modelData, el, listElements, 'showIfThird', 'showIfEmptyThird', 'showIfValueThird', 'showIfValueNotThird', 'showIfNotEmptyThird');
      const isContainerShowed = this.isItemShowByKey(modelData, el, listElements, 'showIfContainer', 'showIfEmptyContainer', 'showIfValueContainer', 'showIfValueNotContainer', 'showIfNotEmptyContainer');
      const isContainerShowedSecondary = this.isItemShowByKey(modelData, el, listElements, 'showIfSecondaryContainer', 'showIfEmptySecondaryContainer', 'showIfValueSecondaryContainer', 'showIfValueNotSecondaryContainer', 'showIfNotEmptySecondaryContainer');
      const isContainerShowedThird = this.isItemShowByKey(modelData, el, listElements, 'showIfThirdContainer', 'showIfEmptyThirdContainer', 'showIfValueThirdContainer', 'showIfValueNotThirdContainer', 'showIfNotEmptyThirdContainer');
      return isItemShowed && isContainerShowed && isItemShowedSecondary && isContainerShowedSecondary && isItemShowedThird && isContainerShowedThird;
    },
    isItemShowByKey(modelData, el, listElements, showIfKey, showIfEmptyKey, showIfValueKey, showIfValueNotKey, showIfNotEmptyKey) {
      // showIf is not set => item is showed
      if (el[showIfKey] == null && el.showIfs == null) {
        return true;
      }

      // Check if showIfNotEmpty is set (the field is filled)
      if (el[showIfNotEmptyKey]) {
        // Field is not filled
        if (!modelData[el[showIfKey]]) {
          return false;
        }
      } else {

        // showIfEmpty is set (No option is selected)
        if (el[showIfEmptyKey]) {
          // Check if showIf item is showed
          // If the refer element has the value, check if the refer element is showed
          const referEl = this.getReferField(el, listElements, showIfKey);
          if (referEl) {
            if (!this.isItemShow(modelData, referEl, listElements)) {
              return false;
            }
          }
          if (el[showIfKey]) {
            const value = modelData[el[showIfKey]];
            if (value == null || value === '') {
              return true;
            }
            if (Array.isArray(value)) {
              if (!value.length) {
                return true;
              }
              // All item is null
              if (!value.some(item => item)) {
                return true;
              }
            }
          }
          // Show one field if some other fields are empty
          if (el.showIfs) {
            for (const showIfModel of el.showIfs) {
              const value = modelData[showIfModel];
              if (value != null && value !== '') {
                return false;
              }
              if (Array.isArray(value)) {
                if (value.length) {
                  if (value.some(item => item)) {
                    return false;
                  }
                }
              }
            }
            return true;
          }
          // The other condition is unset
          if (!el[showIfValueKey] && !el[showIfValueNotKey]) {
            return false;
          }
        }

        if (el[showIfValueNotKey]) {
          const value = modelData[el[showIfKey]];
          if (!value) {
            return false;
          }
          if (Array.isArray(value)) {
            return !value.includes(el[showIfValueNotKey]);
          }
          return value !== el[showIfValueNotKey]
        }

        /* showIfValue is not set =>
        item is only show if the corresponding value of model for showIf is true (Yes/No radio group)
        */
        if (el[showIfValueKey] == null) {
          if (!modelData[el[showIfKey]]) {
            return false;
          }
        } else {
          /* show if value of dropdown option is in list of option (showIfValue is an array)) */
          if (Array.isArray(el[showIfValueKey])) {
            // In case of checkbox, show if at least 1 checked option === el[showIfValueKey]
            if (
              el[showIfValueKey].length === 1 &&
              Array.isArray(modelData[el[showIfKey]])
            ) {
              if (modelData[el[showIfKey]].includes(el[showIfValueKey][0])) {
                return true;
              }
            }
            // In other case, it is not showed if the selected option is not in showIfValue
            let value = modelData[el[showIfKey]];
            // Convert data type for Boolean radio
            if (value === true) {
              value = "Yes";
            }
            if (value === false) {
              value = "No";
            }
            let listCheckValues = el[showIfValueKey];
            // In case of multi languages
            if (modelData.language) {
              const referEl = this.getReferField(el, listElements, showIfKey);
              if (referEl) {
                const mapOptions = this.getMapOptionListByLanguage(referEl, modelData.language);
                const listValueByLanguage = listCheckValues.map(val => mapOptions[val]).filter(val => val);
                listCheckValues = [...listCheckValues, ...listValueByLanguage];
              }
            }
            if (Array.isArray(value)) {
              // Exclude the case value is an empty array, and showIfValue contains undefined
              // That is the case one field is showed if all checkbox options are unchecked
              if (!(value.length === 0 && listCheckValues.includes(undefined))) {
                if (!this.hasCommonElement(value, listCheckValues)) {
                  if (!this.isMatchingOtherOption(value, listCheckValues)) {
                    return false;
                  }
                }
              }
            } else {
              if (!listCheckValues.includes(value)) {
                return false;
              }
            }
          } else {
            /* show if value of dropdown option is one option (showIfValue is string) */
            // Check show if for boolean radio
            let value = modelData[el[showIfKey]];
            // Convert data type for Boolean radio
            if (value === true) {
              value = "Yes";
            }
            if (value === false) {
              value = "No";
            }
            if (value !== el[showIfValueKey]) {
              return false;
            }
          }
        }
      }
      // If the refer element has the value, check if the refer element is showed
      const referEl = this.getReferField(el, listElements, showIfKey);
      if (referEl == null) {
        return true;
      }
      return this.isItemShow(modelData, referEl, listElements);
    },
    getMapOptionListByLanguage(item, language) {
      if (!item.optionList) {
        return {};
      }
      if (!item["optionList_lang_" + language]) {
        return {};
      }
      const listOptions = this.convertStringToArray(item.optionList);
      const listOptionsByLangs = this.convertStringToArray(
        item["optionList_lang_" + language]
      );
      const result = {};
      for (let index = 0; index < listOptions.length; index++) {
        result[listOptions[index]] = listOptionsByLangs[index];
      }
      return result;
    },
    // Check if Other option of checkbox group
    isMatchingOtherOption(listCheckedOptions, listShowOptions) {
      if (!listCheckedOptions || !listShowOptions) {
        return false;
      }
      if (!listCheckedOptions.some(option => option && option.indexOf('other:') === 0)) {
        return false;
      }
      if (!listShowOptions.some(option => option && option.toLowerCase() === 'other')) {
        return false;
      }
      return true;
    },
    // Validate mising file, or file exceed maximum
    isFileValid(file, isRequired, maxSize = 10) {
      if (file == null) {
        return !isRequired;
      }
      if (file.size > maxSize * 1024 * 1024) {
        return false;
      }
      return true;
    },
    // Validate if a list of file contains any invalid file (missing or file size exceed maximum)
    hasInvalidFile(uploadFiles, listFileInfo) {
      for (const item of listFileInfo) {
        if (!this.isFileValid(uploadFiles[item.model], item.isRequired)) {
          return true;
        }
      }
      return false;
    },
    /* This method receive a list of field,
    then filter out all field which is not corresponding with an option.
    In list field input, it contains information of showIf and showIfValue.
    The output will be filtered based on that.
    And it return list of the filtered fields.
    */
    getListFieldModelForOption(listField, option) {
      return listField.filter(field => {
        // Filter out the fields which does not have model property
        if (!field.model) {
          return false;
        }
        // If showIf is not set, that's mean the field is exist on all options
        if (!field.showIf) {
          return true;
        }
        // showIf is set and showIfValue is not set
        if (field.showIfValue == null) {
          // The existence of item depends on the existence of the refer field (field is specified by showIf)
          const referField = listField.find(
            field2 => field2.model === field.showIf
          );
          // Check if the refer field is exist,
          if (!referField.showIf) {
            return true;
          }
          if (!referField.showIfValue) {
            // showIfValue is not set => the yes/no radio
            return true;
          } else {
            // Check if the refer field is exist by value of showIfValue
            return this.isFieldExistForOption(referField, option);
          }
        } else {
          return this.isFieldExistForOption(field, option);
        }
      });
    },
    /*
    Check if field is exist based on it's showIfValue.
    The input field of this function has both showIf and showIfValue property
    */
    isFieldExistForOption(field, option) {
      if (Array.isArray(field.showIfValue)) {
        return field.showIfValue.includes(option);
      } else {
        return field.showIfValue === option;
      }
    },
    // Check if there is duplicate element in array or not
    containsDuplicate(arr) {
      return new Set(arr).size !== arr.length;
    },
    // Check if there is blank element in array or not
    containsBlank(arr) {
      if (!arr) {
        return false;
      }
      return arr.some(el => !el || !el.trim());
    },
    /* Check if a section is visible based on list of status and user types
    A section is visible if visible for both userTypes and userStatus
    For userTypes, section is visible if at least 1 type in userTypes belongs to listVisibleTypes of section
    For userStatus, section is visible if user status is set in listVisibleStatus
    or index of user status >= index of visible beyond status (in list statuses)
    */
    isSectionVisible(dialogSection, user) {
      const userTypes = user.types;
      const userStatus = user.status;
      // Check invisible for userTypes
      if (dialogSection.listVisibleTypes && dialogSection.listVisibleTypes.length > 0) {
        if (userTypes == null || userTypes.length === 0) {
          return false;
        }
        // Check if listVisibleTypes and userTypes has no common element
        if (!dialogSection.listVisibleTypes.some(type => userTypes.includes(type))) {
          return false;
        }
      }

      // If both list visible statuses and visible beyond status are not set, always show
      const listVisibleStatuses = dialogSection.listVisibleStatuses;
      const visibleBeyondStatus = dialogSection.visibleBeyondStatus;
      const listStatuses = user.is_candidate ? this.$store.getters.candidateStatuses : this.$store.getters.employerStatuses;
      if (!this.isVisibleByStatus(listVisibleStatuses, visibleBeyondStatus, userStatus, listStatuses)) {
        return false;
      }
      // Check visible beyond second statuses
      const listVisibleSecondStatuses = this.getBuilderAdditionalSettingByKey(dialogSection, 'visible_second_statuses');
      const visibleBeyondSecondStatus = this.getBuilderAdditionalSettingByKey(dialogSection, 'visible_beyond_second_status');
      const listSecondStatuses = user.is_candidate ? this.$store.getters.candidateSecondStatuses : this.$store.getters.employerSecondStatuses;
      if (!this.isVisibleByStatus(listVisibleSecondStatuses, visibleBeyondSecondStatus, user.second_status, listSecondStatuses)) {
        return false;
      }
      return true;
    },
    getBuilderAdditionalSettingByKey(builder, key) {
      if (!builder) {
        return null;
      }
      if (builder.additionalInformation && builder.additionalInformation[key]) {
        return builder.additionalInformation[key];
      }
      if (builder.additional_information && builder.additional_information[key]) {
        return builder.additional_information[key];
      }
      return null;
    },
    isVisibleByStatus(listVisibleStatuses, visibleBeyondStatus, userStatus, listStatuses) {
      if (
        (!listVisibleStatuses || !listVisibleStatuses.length) &&
        (visibleBeyondStatus == null || visibleBeyondStatus === "")
      ) {
        return true;
      }
      if (listVisibleStatuses.includes(userStatus)) {
        return true;
      }

      const minIndexOfStatus = listStatuses.indexOf(visibleBeyondStatus);
      // If visible beyond status is set
      if (minIndexOfStatus !== -1) {
        const indexOfStatus = listStatuses.indexOf(userStatus);
        if (indexOfStatus >= minIndexOfStatus) {
          return true;
        }
      }
      return false;
    },
    /*
    Compare status and beyondStatus in listStatuses
    Return true if index of status > index of beyondStatus
    If beyondStatus is not in listStatuses, return default value
     */
    compareBeyondStatus(status, beyondStatus, listStatuses, defaultValue) {
      const minIndexOfStatus = listStatuses.indexOf(beyondStatus);
      // If visible beyond status is not set or not in listStatuses
      if (minIndexOfStatus === -1) {
        return defaultValue;
      } else {
        // Compare 2 indices
        const indexOfStatus = listStatuses.indexOf(status);
        if (indexOfStatus >= minIndexOfStatus) {
          return true;
        }
      }
      return false;
    },
    /*
    Compare order of status1, status2 in listStatuses
    Return:
      1 if index of status 1 > index of status 2
      -1 if index of status 1 < index of status 2
      0 if index of status 1 == index of status 2
    */
    compareStatus(status1, status2, listStatuses) {
      const index1 = listStatuses.indexOf(status1);
      const index2 = listStatuses.indexOf(status2);
      if (index1 > index2) {
        return 1;
      } else if (index1 === index2) {
        return 0;
      } else {
        return -1;
      }
    },
    /*
    If input is a string, convert it to array (separate by newline character)
     */
    normalizedArrayValue(value) {
      if (!value) {
        return [];
      }
      if (Array.isArray(value)) {
        return value.filter(item => item != null);
      }
      return value
        .split("\n")
        .map(option => option.trim())
        .filter(option => option.length > 0);
    },
    /*
    Check if applicationData is match with searchData,
    for example: 
    searchData contains first_name: 'Test',
    applicationData contains first_name: 'Test Name' => return true
    */
    isMatchMasterViewSearch(applicationData, searchData) {
      if (!searchData || !Object.keys(searchData).length) {
        return true;
      }
      if (!applicationData) {
        return false;
      }
      for (const key of Object.keys(searchData)) {
        if (key === 'selectedProfileBuilderId') {
          continue;
        }
        let searchValue = searchData[key];
        if (!searchData) {
          continue;
        }
        let value = applicationData[key];
        // Time Picker
        if (typeof searchValue === 'object') {
          if (searchValue.A && searchValue.hh && searchValue.mm) {
            searchValue = this.getTimeString(searchValue);
          }
        }
        if (Array.isArray(searchValue)) {
          // Empty array => match
          if (!searchValue.length) {
            continue;
          }
          if (Array.isArray(value)) {
            searchValue = searchValue.map(item => this.getHtmlText(item));
            value = value.map(item => this.getHtmlText(item));
            if (this.hasCommonElement(searchValue, value)) {
              continue;
            } else {
              return false;
            }
          } else if (['string', 'number'].includes(typeof value)) {
            if (searchValue.includes(value)) {
              continue;
            } else {
              return false;
            }
          }
          if (value == null) {
            return false;
          }
        } else if (typeof searchValue === 'string') {
          if (value == null) {
            return false;
          }
          if (String(value).toLowerCase().includes(searchValue.toLowerCase())) {
            continue;
          } else {
            return false;
          }
        }
      }
      return true;
    },
    hasSearchCondition(condition) {
      if (condition == null) {
        return false;
      }
      // Empty object
      if (Object.keys(condition).length === 0) {
        return false;
      }
      if (condition.listConditions == null) {
        return false;
      }
      if (condition.listConditions.length === 0) {
        return false;
      }
      return true;
    },
    /*
    Check if data inside applicationData is match with listCombinedCondition
    listCombinedCondition is an array of 1 or some list Condition (each list Condition is used for a section)
    */
    isMatchCombinedConditions(listCombinedConditions, applicationData) {
      for (const combinedCondition of listCombinedConditions) {
        if (
          combinedCondition.listConditions == null ||
          combinedCondition.listConditions.length === 0
        ) {
          continue;
        }
        let listConditions = combinedCondition.listConditions;
        const listGroupConditions = listConditions.filter(condition => condition.isGroup);
        // Filter out incomplete conditions
        listConditions = listConditions.filter(
          condition => {
            if (condition.operator) {
              return condition.value || condition.highValue || condition.lowValue
            } else {
              // Table condition
              return condition.value && condition.item;
            }
          }
        )
        // Match if any condition is match
        if (combinedCondition.logic_combination === "ANY") {
          for (const condition of listConditions) {
            if (
              this.isMatchAtomicCondition(
                condition,
                applicationData[condition.model]
              )
            ) {
              // 1 condition is match => match
              return true;
            }
          }
          for (const groupCondition of listGroupConditions) {
            if (this.isMatchCombinedConditions([groupCondition.condition], applicationData)) {
              // 1 condition is match => match
              return true;
            }
          }
        } else {
          // Match if all condition is match
          let isMatch = true;
          for (const condition of listConditions) {
            if (
              !this.isMatchAtomicCondition(
                condition,
                applicationData[condition.model]
              )
            ) {
              // 1 condition is not match => not match
              isMatch = false;
            }
          }
          for (const groupCondition of listGroupConditions) {
            if (!this.isMatchCombinedConditions([groupCondition.condition], applicationData)) {
              // 1 condition is not match => not match
              isMatch = false;
            }
          }
          if (isMatch) {
            return true;
          }
        }
      }
      return false;
    },
    /* Check if automic condition is match
    example:
    condition: {
      model: 'selector1',
      operator: 'IS'
      value: 'Yes'
    }
    If value is 'Yes'
    => return true (match)
    If value is 'No'
    => return false (not match)
    */
    isMatchAtomicCondition(condition, value) {
      // Radtion table or checkbox table
      if (!condition.operator) {
        return this.isMatchTableCondition(condition, value);
      }
      // Boolean selector fields
      if (value === true) {
        value = "Yes";
      }
      if (value === false) {
        value = "No";
      }
      let conditionValue = condition.value;
      if (conditionValue === "PREDEFINED_BLANK_STRING") {
        condition.isBlank = true;
        conditionValue = "";
      }
      if (Array.isArray(conditionValue)) {
        if (conditionValue.includes("PREDEFINED_BLANK_STRING") && !conditionValue.includes("")) {
          conditionValue.push("");
        }
      }
      switch (condition.operator) {
        case CONDITION_OPERATOR_OPTIONS.IS.id:
          // Equal comparision
          if (value && conditionValue && !isNaN(value) && !isNaN(conditionValue)) {
            return Number(conditionValue) === Number(value);
          }
          if (Array.isArray(conditionValue) && (typeof value === 'string')) {
            return conditionValue.includes(value);
          }
          if (condition.isBlank) {
            if (value == null) {
              return true;
            }
          }
          return conditionValue === value;
        case CONDITION_OPERATOR_OPTIONS.IS_NOT.id:
          // Unequal comparision
          if (value && conditionValue && !isNaN(value) && !isNaN(conditionValue)) {
            return Number(conditionValue) !== Number(value);
          }
          return conditionValue !== value;
        case CONDITION_OPERATOR_OPTIONS.IS_IN.id:
          // Check if condition.values contains value
          let arrVal = this.normalizedArrayValue(conditionValue);
          return arrVal.includes(value);
        case CONDITION_OPERATOR_OPTIONS.IS_NOT_IN.id:
          // Check if condition.values does not contains value
          arrVal = this.normalizedArrayValue(conditionValue);
          return !arrVal.includes(value);
        case CONDITION_OPERATOR_OPTIONS.CONTAINS.id:
          // Check if value contains conditionValue
          if (value == null || conditionValue == null) {
            return false;
          }
          return value.toLowerCase().includes(conditionValue.toLowerCase());
        case CONDITION_OPERATOR_OPTIONS.NOT_CONTAINS.id:
          // Check if value contains conditionValue
          if (value == null || conditionValue == null) {
            return false;
          }
          return !value.toLowerCase().includes(conditionValue.toLowerCase());
        case CONDITION_OPERATOR_OPTIONS.IS_BLANK.id:
          return !value;
        case CONDITION_OPERATOR_OPTIONS.UPLOADED.id:
          console.log(value);
          return !!value;
        case CONDITION_OPERATOR_OPTIONS.FILE_INFO_UPLOADED.id:
          console.log(value);
          return !!value;
        case CONDITION_OPERATOR_OPTIONS.START_WITH.id:
          // Check if value start with conditionValue
          if (value == null || conditionValue == null) {
            return false;
          }
          return value.toLowerCase().startsWith(conditionValue.toLowerCase());
        case CONDITION_OPERATOR_OPTIONS.END_WITH.id:
          // Check if value end with conditionValue
          if (value == null || conditionValue == null) {
            return false;
          }
          return value.toLowerCase().endsWith(conditionValue.toLowerCase());
        case CONDITION_OPERATOR_OPTIONS.GT.id:
          if (value && conditionValue && !isNaN(value) && !isNaN(conditionValue)) {
            // Check if value > conditionValue
            return Number(value) > Number(conditionValue);
          } else {
            return String(value || "") > String(conditionValue);
          }
        case CONDITION_OPERATOR_OPTIONS.LT.id:
          // Check if value < conditionValue
          if (value && conditionValue && !isNaN(value) && !isNaN(conditionValue)) {
            return Number(value) < Number(conditionValue);
          } else {
            return String(value || "") < String(conditionValue);
          }
        case CONDITION_OPERATOR_OPTIONS.GE.id:
          // Check if value >= conditionValue
          if (value && conditionValue && !isNaN(value) && !isNaN(conditionValue)) {
            return Number(value) >= Number(conditionValue);
          } else {
            return String(value || "") >= String(conditionValue);
          }
        case CONDITION_OPERATOR_OPTIONS.LE.id:
          // Check if value <= conditionValue
          if (value && conditionValue && !isNaN(value) && !isNaN(conditionValue)) {
            return Number(value) <= Number(conditionValue);
          } else {
            return String(value || "") <= String(conditionValue);
          }
        case CONDITION_OPERATOR_OPTIONS.BETWEEN.id:
          // Check if condition.lowValue <= value <= condition.highValue
          if (value && condition.lowValue && !isNaN(value) && !isNaN(condition.lowValue)) {
            return (
              Number(value) <= Number(condition.highValue) &&
              Number(value) >= Number(condition.lowValue)
            );
          } else {
            return (
              String(value || "") <= String(condition.highValue) &&
              String(value || "") >= String(condition.lowValue)
            );
          }
        case CONDITION_OPERATOR_OPTIONS.IS_DATE.id:
          // Check if value is a date (date comparision)
          return this.dateInDjangoFormat(value) === this.dateInDjangoFormat(conditionValue);
        case CONDITION_OPERATOR_OPTIONS.IS_NOT_DATE.id:
          // Check if value is not a date (date comparision)
          return this.dateInDjangoFormat(value) !== this.dateInDjangoFormat(conditionValue);
        case CONDITION_OPERATOR_OPTIONS.BEFORE.id:
          // Check if value is before conditionValue (date comparision)
          return this.dateInDjangoFormat(value) < this.dateInDjangoFormat(conditionValue);
        case CONDITION_OPERATOR_OPTIONS.AFTER.id:
          // Check if value is after conditionValue (date comparision)
          return this.dateInDjangoFormat(value) > this.dateInDjangoFormat(conditionValue);
        case CONDITION_OPERATOR_OPTIONS.BE.id:
          // Check if value is before or equal conditionValue (date comparision)
          return this.dateInDjangoFormat(value) <= this.dateInDjangoFormat(conditionValue);
        case CONDITION_OPERATOR_OPTIONS.AE.id:
          // Check if value is after or equal conditionValue (date comparision)
          return this.dateInDjangoFormat(value) >= this.dateInDjangoFormat(conditionValue);
        case CONDITION_OPERATOR_OPTIONS.BETWEEN_DATE.id:
          // Check if condition.lowValue <= value <= condition.highValue (compare date)
          return (
            value && this.dateInDjangoFormat(value) <= this.dateInDjangoFormat(condition.highValue) &&
            this.dateInDjangoFormat(value) >= this.dateInDjangoFormat(condition.lowValue)
          );
        case CONDITION_OPERATOR_OPTIONS.DAY_IS.id:
          return value && new Date(value).getDate() === conditionValue;
        case CONDITION_OPERATOR_OPTIONS.MONTH_IS.id:
          return value && new Date(value).getMonth() === (conditionValue - 1);
        case CONDITION_OPERATOR_OPTIONS.YEAR_IS.id:
          return value && new Date(value).getFullYear() === Number(conditionValue);
        case CONDITION_OPERATOR_OPTIONS.HAS.id:
          if (!value) {
            return false;
          }
          // Check if value contains all value inside conditionValue
          arrVal = this.normalizedArrayValue(conditionValue);
          return arrVal.every(val => value.includes(val));
        case CONDITION_OPERATOR_OPTIONS.HAS_NOT.id:
          if (!value) {
            return true;
          }
          // Check if value does not contains all value inside conditionValue
          arrVal = this.normalizedArrayValue(conditionValue);
          return !this.hasCommonElement(arrVal, value);
        case CONDITION_OPERATOR_OPTIONS.HAS_PARTIAL.id:
          if (!value) {
            return false;
          }
          // Check if value contains all value inside conditionValue
          arrVal = this.normalizedArrayValue(conditionValue);
          return this.hasCommonElement(arrVal, value);
      }
    },
    isMatchTableCondition(condition, value) {
      if (condition.value && condition.item) {
        if (!value) {
          return false;
        }
        if (!Array.isArray(value)) {
          return false;
        }
        for (const line of value) {
          if (!line) {
            continue;
          }
          const tokens = line.split(':');
          if (tokens.length < 2) {
            continue;
          }
          if (!condition.item.includes(tokens[0].trim())) {
            continue;
          }
          const optionTokens = tokens[1].split(',');
          for (const optionToken of optionTokens) {
            if (condition.value.includes(optionToken.trim())) {
              return true;
            }
          }
        }
      }
      return false;
    },
    getConditionGroupTypeOfField(field) {
      if (field == null) {
        // Default
        return "DEFAULT";
      }
      // For datepicker
      if (field.type === FORM_TYPE.DATEPICKER) {
        return "DATE";
      }
      // For multiselect component
      if (field.type === FORM_TYPE.MULTI_SELECT) {
        if (field.isMultiple || field.isMulti) {
          return "MULTI_SELECT";
        } else {
          return "SINGLE_SELECT";
        }
      }
      // For other single select item (dropdown, radio group)
      if ([FORM_TYPE.DROPDOWN, FORM_TYPE.RADIO].includes(field.type)) {
        return "SINGLE_SELECT";
      }
      // For other multi select item
      if ([FORM_TYPE.CHECKBOX].includes(field.type)) {
        return "MULTI_SELECT";
      }
      // For table items
      if (
        [FORM_TYPE.RADIO_TABLE, FORM_TYPE.CHECKBOX_TABLE].includes(field.type)
      ) {
        return "TABLE";
      }
      // Default
      return "DEFAULT";
    },
    /*
    Calculate user properties (user type, user tag) based on list of condition
    If data is match with type/tag condition, the array result will contains type/tag in condition.type/tag
    Structure of listPropertyConditions (It can be listTypeConditions or listTagConditions): 
      [
        {
          conditions: [
            {
              conditions: [
                {
                  listConditions: [
                    list of automic condition
                  ],
                  logic_combination: ALL/ANY
                }
              ],
              type: "type" // Or tag: "tag"
            }
          ]
        }
      ]
    */
    calculateUserProperties(listPropertyConditions, data, originalProperties, propertyName) {
      if (listPropertyConditions == null) {
        return [];
      }
      // Clear existing property if the clear existing property flag is set for at least 1 condition
      const keyClearExisting = 'clearExisting' + this.capitalizeFirstLetter(this.convertToPluralForm(propertyName));
      const keyClearExistingExclude = 'clearExistingExclude' + this.capitalizeFirstLetter(this.convertToPluralForm(propertyName));
      let clearExistingProperty = false;
      let clearExistingExclude = null;
      for (const propertyCondition of listPropertyConditions) {
        if (propertyCondition[keyClearExisting] === true) {
          clearExistingProperty = true;
          clearExistingExclude = propertyCondition[keyClearExistingExclude];
        }
      }

      let userProperties = [];
      if (originalProperties) {
        if (clearExistingProperty) {
          if (clearExistingExclude && clearExistingExclude.length) {
            // Keep the items which are in the exclude list
            userProperties = originalProperties.filter(item => clearExistingExclude.includes(item));
          }
        } else {
          // Keep current properties if clearExistingProperty flag is not set
          userProperties = originalProperties;
        }
      }

      let hasCondition = false;
      for (const propertyCondition of listPropertyConditions) {
        if (propertyCondition == null || propertyCondition.conditions == null) {
          continue;
        }
        for (const condition of propertyCondition.conditions) {
          if (condition[propertyName]) {
            hasCondition = true;
            if (this.isMatchCombinedConditions([condition.conditions], data)) {
              userProperties.push(condition[propertyName]);
            }
          }
        }
      }
      // If does not have any condition, keep current properties
      if (!hasCondition) {
        if (originalProperties == null) {
          return [];
        }
        return originalProperties;
      }
      return this.deduplicateArrayOfObject(userProperties);
    },
    // Apply for non array field property (for example: status, second_status)
    calculateUserProperty(listPropertyConditions, data, propertyName) {
      if (listPropertyConditions == null) {
        return null;
      }
      for (const propertyCondition of listPropertyConditions) {
        if (propertyCondition == null || propertyCondition.conditions == null) {
          continue;
        }
        for (const condition of propertyCondition.conditions) {
          if (condition[propertyName]) {
            if (this.isMatchCombinedConditions([condition.conditions], data)) {
              return condition
            }
          }
        }
      }

      return null;
    },
    // Get error condition based on list of error condition
    // If there is not match any condition, return null
    getErrorFromCondition(listErrorConditions, data) {
      if (listErrorConditions == null) {
        return [];
      }
      for (const errorCondition of listErrorConditions) {
        if (errorCondition == null || errorCondition.conditions == null) {
          continue;
        }
        for (const condition of errorCondition.conditions) {
          if (this.isMatchCombinedConditions([condition.conditions], data)) {
            return condition.errorMessage;
          }
        }
      }
      return null;
    },
    getMembershipInfoFromCondition(listMembershipConditions, data) {
      if (listMembershipConditions == null) {
        return [];
      }
      for (const membershipCondition of listMembershipConditions) {
        if (membershipCondition == null || membershipCondition.conditions == null) {
          continue;
        }
        for (const condition of membershipCondition.conditions) {
          if (this.isMatchCombinedConditions([condition.conditions], data)) {
            const listKeys = ['type', 'amount', 'frequency', 'duration', 'freePrices'];
            const result = {};
            listKeys.forEach(key => {
              result[key] = condition[key];
            });
            result.date = this.dateInDjangoFormat(new Date());
            return result;
          }
        }
      }
      return null;
    },
    /*
    This function reset the field if it is not showed
    For example: if the field corresponding with model 'selector1' is not showed (because it depend on value of other field)
    it will reset value of 'selector1' in applicationData
    */
    resetValueOfHiddenField(target, allInfo, listFields, model, keepKey = false) {
      // Find the corresponding field based on model
      const listModelFields = listFields.filter(field => field.model === model);
      // No field
      if (listModelFields.length === 0) {
        return;
      }
      let isShow = false;
      for (const field of listModelFields) {
        // At least one field is showed
        if (this.isItemShow(allInfo, field, listFields)) {
          isShow = true;
          break;
        }
      }
      if (!isShow) {
        if (keepKey) {
          if (typeof target[model] === 'string') {
            target[model] = '';
          } else if (Array.isArray(target[model])) {
            target[model] = [];
          } else {
            delete target[model];
          }
        } else {
          delete target[model];
        }
      }
    },
    /*
    Check if there is no data for the section (user does not input any information for this section)
    Only check for non-document fields
    */
    isEmptySection(listFields) {
      const selectedData = this.extractSelectedFields(
        this.user,
        listFields.filter(
          (field) => field.type !== FORM_TYPE.FILE && field.model != null
        )
      );
      for (const val of Object.values(selectedData)) {
        if (val != null) {
          if (!this.isEmptyValue(val)) {
            return false;
          }
        }
      }
      return true;
    },
    /*
    Get document body from template body
    by replace preseved word by data value
    */
    async getDocumentBodyFromTemplate(document, data) {
      const templateBody = document.body;
      const signingDate = document.signing_date;
      // Replace first name, last name, email, phone
      let mapReplaceKey = {
        fname: 'first_name',
        lname: 'last_name',
        email: 'email',
        phone: 'phone'
      };
      if (document.sign_by_both) {
        if (data.is_employer) {
          mapReplaceKey = {
            client_fname: 'first_name',
            client_lname: 'last_name',
            client_email: 'email',
            client_phone: 'phone'
          };
        } else {
          mapReplaceKey = {
            candidate_fname: 'first_name',
            candidate_lname: 'last_name',
            candidate_email: 'email',
            candidate_phone: 'phone'
          };
        }
      }
      let documentBody = templateBody;
      for (const [presevedWord, objectKey] of Object.entries(mapReplaceKey)) {
        documentBody = documentBody.split(`[[${presevedWord}]]`).join(data[objectKey]);
      }
      // Replace date 
      if (signingDate) {
        documentBody = documentBody.split(`[[date]]`).join(new Date(signingDate).toDateString());
      } else {
        documentBody = documentBody.split(`[[date]]`).join(new Date().toDateString());
      }

      // Replace address
      let address = data.address1
      if (data.address2) {
        address = address + ' ' + data.address2
      }
      address = address + ', ' + data.city + ', ' + data.provincestate + ', ' + data.postal_code
      let addressTag = "address";
      if (document.sign_by_both) {
        if (data.is_employer) {
          addressTag = "client_address"
        } else {
          addressTag = "candidate_address"
        }
      }
      documentBody = documentBody.split(`[[${addressTag}]]`).join(address);
      const listTags = this.extractTagFromString(documentBody);
      // Replace other tags
      for (const tag of listTags) {
        // Ingore field tags
        if (tag.indexOf('field') === 0) {
          continue;
        }
        if (tag.indexOf('api|') === 0) {
          documentBody = this.replaceAllText(documentBody, `[[${tag}]]`, this.getReplacedApiTag(tag, data));
          continue;
        }
        // Ignore checkbox tag
        if (tag.indexOf("x ") === 0) {
          continue;
        }
        let value;
        let normalizedTag = '';
        if (document.sign_by_both) {
          if (data.is_employer) {
            if (tag.indexOf('client-') === 0) {
              // Only replace client tag
              normalizedTag = tag.replace('client-', '');
            } else {
              continue;
            }
          } else {
            if (tag.indexOf('candidate-') === 0) {
              // Only replace candidate tag
              normalizedTag = tag.replace('candidate-', '');
            } else {
              continue;
            }
          }
        } else {
          normalizedTag = tag;
        }
        if (['children', 'pets'].includes(normalizedTag)) {
          const mapTypes = {
            children: MAP_DIALOG_SECTION.Children,
            pets: MAP_DIALOG_SECTION.Pet
          }
          value = await this.getProfileSectionContent(data, data[normalizedTag], mapTypes[normalizedTag].name, false, true);
          documentBody = documentBody.split(`[[${normalizedTag}]]`).join(value);
          continue;
        }
        const { model, shareIndex, displayStyle, defaultValue } = this.parseTagField(normalizedTag);
        console.log(model, shareIndex, displayStyle, defaultValue);
        value = this.getDisplayValueInline(data, model, shareIndex, displayStyle, defaultValue);
        if (value) {
          documentBody = documentBody.split(`[[${tag}]]`).join(value);
        } else {
          try {
            // remove boundary text
            const searchRegExp = new RegExp(`\\(\\(\\([^\)]*\[\[${tag}\]\][^\)]*\\)\\)\\)`, 'gmi');
            documentBody = documentBody.replace(searchRegExp, '');
          } catch (_) {

          }
          documentBody = documentBody.split(`[[${tag}]]`).join('');
        }
      }
      documentBody = this.removeTextInString(documentBody, ['(((', ')))']);
      return documentBody;
    },
    // Compare 2 input text by ignore space, punctuation (case insensitive)
    compareTextWithoutPunctuation(input1, input2) {
      if (!input1 || !input2) {
        return false;
      }
      const normalizeInput1 = input1.toLowerCase().replace(REGEX_NORMALIZE_TEXT, "");
      const normalizeInput2 = input2.toLowerCase().replace(REGEX_NORMALIZE_TEXT, "");
      return normalizeInput1 === normalizeInput2;
    },
    // Get common value of the two arrays
    getArraysIntersection(a1, a2) {
      if (a1 == null || a2 == null) {
        return [];
      }
      return a1.filter(n => a2.includes(n));
    },
    // Convert string to list of option (separator is space character) 
    convertStringToArray(input) {
      if (Array.isArray(input)) {
        return input;
      }
      return input
        .split("\n")
        .map((option) => option.trim())
        .filter((option) => option.length > 0);
    },
    // Check if a model is used for boolean radio
    isBooleanRadioModel(model) {
      if (model == null) {
        return false;
      }
      if (model.includes('boolean_selector')) {
        return true;
      }
      if (['current_role', "is_out_of_town", "sick_children", "graduated", "skip_charge", "hide_from_job_board", "visible_to_candidates"].includes(model)) {
        return true;
      }
      return false;
    },
    // Find duplicate elements in array
    findDuplicates(arr) {
      if (!arr) {
        console.log('CHECKING DUPLICATE: Empty Array');
      }
      const len = arr.length;
      // initialize ifPresent as false
      let ifPresent = false;

      // ArrayList to store the output
      let al = new Array();

      for (let i = 0; i < len - 1; i++) {
        for (let j = i + 1; j < len; j++) {
          if (arr[i] == arr[j]) {
            // checking if element is
            // present in the ArrayList
            // or not if present then break
            if (al.includes(arr[i])) {
              break;
            }

            // if element is not present in the
            // ArrayList then add it to ArrayList
            // and make ifPresent at true
            else {
              al.push(arr[i]);
              ifPresent = true;
            }
          }
        }
      }

      // if duplicates is present
      // then print ArrayList
      if (ifPresent == true) {
        console.log('CHECKING DUPLICATE: List of duplicates: ', al);
      }
      else {
        console.log("CHECKING DUPLICATE: No duplicates present in arrays");
      }
    },
    /* Check if inputString is in a mixed array
    Structure of mixed array: each element is String or Array of String
    For example: [["a", "b"], "c"]
    */
    isInMixedArray(mixedArray, inputString) {
      if (!mixedArray) {
        return false;
      }
      for (const item of mixedArray) {
        if (Array.isArray(item)) {
          if (item.includes(inputString)) {
            return true;
          }
        } else {
          if (item === inputString) {
            return true;
          }
        }
      }
      return false;
    },
    /*
    Find list of email notification when user submit application form or submit profile section
    */
    getListEmailSubmissionNotification(listEmails, listEmailLocations, userLocations) {
      let result = [];
      if (listEmails) {
        result = [...listEmails];
      }
      if (listEmailLocations) {
        for (const emailLocation of listEmailLocations) {
          if (!emailLocation.email) {
            continue;
          }
          const locations = emailLocation.locations;
          // If locations are undefined, the email will be used for all locations
          if (!locations || !locations.length) {
            result.push(emailLocation.email);
            continue;
          }
          // locations and userlocations has at least one common item
          if (this.hasCommonElement(locations, userLocations)) {
            result.push(emailLocation.email);
          }
        }
      }
      result = result.filter(item => item); // Remove empty item
      return [...new Set(result)]; // Remove duplicated email
    },
    /* Check if row is fulled
     For example:
     1 row is full if it contains 1 item, which has 1 per row
     1 row is full if it contains 2 items, each take 1/2 row
     1 row is full if it contains 3 items, each take 1/3 row, or 1/2 + 1/4 + 1/4
     ...
    */
    isFullBootstrapRow(listItems) {
      let total = 0;
      for (const item of listItems) {
        if (item.itemPerRow === 0) {
          if (item.isLast) {
            return true;
          }
          continue;
        }
        if (!item.itemPerRow) {
          item.itemPerRow = 1;
        }
        total += 12 / Number(item.itemPerRow)
      }
      return total >= 12;
    },
    // Get display value of cell in table
    getTableCellContent(row, field, listFields = []) {
      const listDateModel = [
        "created_date",
        "last_login",
        "last_updated_date",
        "recent_access",
        "last_activity",
        "last_contacted_date"
      ];
      const listTimeModel = [
        "start_time",
        "end_time",
        "actual_start_time",
        "actual_end_time",
      ];
      if (field.transformFunction) {
        return field.transformFunction(row);
      }
      if (field.model === "first_name_last_name") {
        return row["first_name"] + " " + row["last_name"];
      }
      if (field.model === "secondary_first_name_secondary_last_name") {
        return row["secondary_first_name"] + " " + row["secondary_last_name"];
      }
      const value = row[field.model];
      if (listDateModel.includes(field.model)) {
        if (!value) {
          return "";
        }
        return new Date(value).toDateString();
      }
      if (listTimeModel.includes(field.model)) {
        if (!value) {
          return "";
        }
        return this.djangotimeformatAMPM(value);
      }
      if (Array.isArray(value)) {
        if (field.model === 'modelMatches') {
          return value.map(model => {
            let label;
            if (listFields) {
              const field = listFields.find(field => field.model === model);
              if (field) {
                label = field.label;
              }
              if (!label) {
                label = this.convertUnderscoreToLabel(model);
              }
            }
            let fieldValue = row[model];
            if (listDateModel.includes(model)) {
              fieldValue = new Date(fieldValue).toDateString();
            }
            if (listTimeModel.includes(model)) {
              fieldValue = this.djangotimeformatAMPM(fieldValue);
            }

            return label + ': ' + fieldValue;
          }).join("\n");
        } else {
          // Find the list of options, based on that to prevent from displaying obsolete options
          let optionList = [];
          if (field.model === 'types') {
            if (row.is_candidate) {
              optionList = this.$store.getters.candidateTypes;
            } else if (row.is_employer) {
              optionList = this.$store.getters.employerTypes;
            }
          }
          if (optionList && optionList.length) {
            const result = [];
            for (const option of optionList) {
              if (value.includes(option)) {
                result.push(option);
              }
            }
            return this.deduplicateArrayOfObject(result).join(", ");
          } else {
            return this.deduplicateArrayOfObject(value).join(", ");
          }
        }
      }
      if ([FORM_TYPE.RADIO, FORM_TYPE.MULTI_SELECT].includes(field.type) && field.hasOther) {
        return this.removeOtherRadioPrefix(value);
      }
      return value;
    },
    isEffectiveObject(availability, date) {
      const normalizedDate = this.dateInDjangoFormat(date);
      if (availability.effective_date > normalizedDate) {
        return false;
      }
      if (availability.effective_until) {
        if (availability.effective_until < normalizedDate) {
          return false;
        }
      }
      return true;
    },
    isDocumentUploaded(data) {
      if (!data) {
        return false;
      }
      if (this.convertToAbsolutePath(data).endsWith(DEFAULT_PROFILE_IMAGE_SUFFIX)) {
        return false;
      }
      return true;
    },
    updateDerivedModel(objectData, listFields) {
      if (!listFields || !objectData) {
        return;
      }
      for (const field of listFields) {
        if (!field.derivedModel || !field.derivedOptionList) {
          continue;
        }
        if (!field.model) {
          continue;
        }
        const value = objectData[field.model];
        if (!value) {
          continue;
        }
        const optionList = this.convertStringToArray(field.optionList);
        const derivedOptionList = this.convertStringToArray(field.derivedOptionList);
        if (Array.isArray(value)) {
          // Multi selection
          const listDerivedValue = [];
          for (const item of value) {
            // Find index of selection
            let indexOfSelection = optionList.indexOf(item);
            // Check if other option is selected
            if (indexOfSelection < 0 && item.indexOf('other:') === 0) {
              indexOfSelection = optionList.length - 1;
            }
            if (indexOfSelection < 0) {
              continue;
            }
            listDerivedValue.push(derivedOptionList[indexOfSelection]);
          }
          objectData[field.derivedModel] = listDerivedValue;
        } else {
          // Single selection
          // Find index of selection
          let indexOfSelection = optionList.indexOf(value);
          // Check if other option is selected
          if (indexOfSelection < 0 && value.indexOf('other:') === 0) {
            indexOfSelection = optionList.length - 1;
          }
          if (indexOfSelection < 0 && value.indexOf(RADIO_OTHER_OPTIONS_PREFIX) === 0) {
            indexOfSelection = optionList.length - 1;
          }
          console.log(indexOfSelection);
          if (indexOfSelection < 0) {
            continue;
          }
          objectData[field.derivedModel] = derivedOptionList[indexOfSelection];
        }
        console.log(objectData)
      }
    },
    currencySign(agencyCurrency) {
      let symbol;
      switch (agencyCurrency) {
        case "USD":
          symbol = "$"
          break;
        case "AUD":
          symbol = "A$"
          break;
        case "BGN":
          symbol = "Лв."
          break;
        case "BRL":
          symbol = "R$"
          break;
        case "CAD":
          symbol = "C$"
          break;
        case "CZK":
          symbol = "Kč"
          break;
        case "DKK":
          symbol = "kr"
          break;
        case "EUR":
          symbol = "€"
          break;
        case "GBP":
          symbol = "£"
          break;
        case "HKD":
          symbol = "HK$"
          break;
        case "HUF":
          symbol = "Ft"
          break;
        case "INR":
          symbol = "₹"
          break;
        case "JPY":
          symbol = "¥"
          break;
        case "MXN":
          symbol = "Mex$"
          break;
        case "MYR":
          symbol = "RM"
          break;
        case "NOK":
          symbol = "kr"
          break;
        case "NZD":
          symbol = "NZ$"
          break;
        case "PLN":
          symbol = "zł"
          break;
        case "RON":
          symbol = "L"
          break;
        case "SEK":
          symbol = "kr"
          break;
        case "SGD":
          symbol = "S$"
          break;
        default:
          symbol = agencyCurrency;
          break;
      }
      return symbol;
    },
    addAdditionalScheduling(adminSetting, mapReplaceValues, hasTag = false) {
      if (adminSetting && adminSetting.additional_scheduling_links) {
        for (const linkObj of adminSetting.additional_scheduling_links) {
          if (hasTag) {
            mapReplaceValues[`[[${linkObj.tag}]]`] = linkObj.link;
          } else {
            mapReplaceValues[linkObj.tag] = linkObj.link;
          }
        }
      }
    },
    isDisableConfirmCancellation() {
      if (this.$route &&
        [
          "Application Form Builder",
          "Application Form Builder with Agency Name",
        ].includes(this.$route.name)) {
        return this.$store.getters.disableWarningCancelPopupApplicationForm
      }
      return false;
    },
    getErrorMessage(errorInfo) {
      if (errorInfo.message) {
        return errorInfo.message;
      }
      let result = errorInfo.type;
      if (errorInfo.field) {
        result += `: ${errorInfo.field.label}`
      }
      return result;
    },
    getMissingValueWarningMessage(listFields) {
      const listLabels = listFields.map(field => `<li>${this.getFieldPropertyByLang(field, 'label')}</li>`)
      return listLabels.join('');
    },
  }
});



// WEBPACK FOOTER //
// ./src/mixins/data-handling.js